import React, { useState } from "react";
import { createOrgProfile } from "../Services/orgService";
import { useNavigate } from "react-router-dom";
import { IOrgProfileData } from "../Interfaces/IorgProfile";
import Swal from "sweetalert2";
import { indianStates } from "../Services/CommonService";

const OrgProfileForm = () => {
  const [showAddressPopup, setShowAddressPopup] = useState(false);
  const [showGSTField, setShowGSTField] = useState(false);
  const [apiResponse, setApiResponse] = useState<string | null>(null);
  const [formData, setFormData] = useState<Partial<IOrgProfileData>>({
    timeZone: "IST",
    orgLocation:"India",
    currency:"INR",
  });
  const navigate = useNavigate();

  const handleAddAddressClick = () => {
    setShowAddressPopup(true);
  };

  const handleClosePopup = () => {
    setShowAddressPopup(false);
  };

  const handleGSTCheckbox = () => {
    setShowGSTField(!showGSTField);
  };

  const handleChange = (
    e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>
  ) => {
    const { name, value } = e.target;
    if (name === "mobileNumber") {
      const validNumber = /^\d{10}$/;
      if (validNumber.test(value)) {
        setFormData((prev) => ({ ...prev, [name]: value }));
      }
    } else {
      setFormData((prev) => ({ ...prev, [name]: value }));
    }
  };
  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    try {
      const response = await createOrgProfile(formData);
      setApiResponse(
        `Record's saved successfully. Your User ID: ${response.userDetails.userId} and Password: ${response.userDetails.password}`
      );
    } catch (error: any) {
      setApiResponse(error.message);
    }
  };

  const handleRedirect = () => {
    navigate("/");
  };

  return (
    <div
      style={{
        maxWidth: "600px",
        margin: "20px auto",
        padding: "20px",
        border: "1px solid #ccc",
        borderRadius: "8px",
        backgroundColor: "#f9f9f9",
      }}
    >
      <form
        onSubmit={handleSubmit}
        style={{
          margin: "20px 0",
          padding: "20px",
          border: "1px solid #ccc",
          borderRadius: "8px",
          backgroundColor: "#f9f9f9",
        }}
      >
        <h2>Setup Your Org Profile</h2>
        <div className="form-group_org">
          <label
            style={{
              fontWeight: "bold",
              marginRight: "10px",
              whiteSpace: "nowrap",
            }}
          >
            Org Name<span style={{ color: "red" }}>*</span>
          </label>
          <input name="OrgName" type="text" onChange={handleChange} required />
        </div>

        <div className="form-group_org">
          <label
            style={{
              fontWeight: "bold",
              marginRight: "10px",
              whiteSpace: "nowrap",
            }}
          >
            Org Location<span style={{ color: "red" }}>*</span>
          </label>
          <select name="orgLocation" onChange={handleChange} required disabled>
            <option value="India">India</option>
            <option value="USA">USA</option>
          </select>
        </div>

        <div className="form-group_org">
          <label
            style={{
              fontWeight: "bold",
              marginRight: "10px",
              whiteSpace: "nowrap",
            }}
          >
            Email<span style={{ color: "red" }}>*</span>
          </label>
          <input name="Email" type="email" onChange={handleChange} required />
        </div>

        <div className="form-group_org">
          <label
            style={{
              fontWeight: "bold",
              marginRight: "10px",
              whiteSpace: "nowrap",
            }}
          >
            Mobile Number<span style={{ color: "red" }}>*</span>
          </label>
          <input
            name="Mob"
            type="number"
            // onChange={handleChange}
            onChange={(e) => {
              const value = e.target.value;
              if (value.startsWith("-")) {
                Swal.fire({
                  title: "Error",
                  text: "Mobile number should not be negative",
                  icon: "error",
                  customClass: {
                    container: "swal-validation-errors",
                  },
                  backdrop: `
                                    rgba(0,0,0,0.4)
                                    center
                                    no-repeat
                                `,
                });
                const swalValidationErrors = document.querySelector(
                  ".swal-validation-errors"
                ) as HTMLElement;
                if (swalValidationErrors) {
                  swalValidationErrors.style.zIndex = "10000";
                }
                e.target.value = "";
                setFormData((prev) => ({
                  ...prev,
                  phone: "",
                }));
              } else if (value.length > 11) {
                Swal.fire({
                  title: "Error",
                  text: "Mobile number is invalid",
                  icon: "error",
                  customClass: {
                    container: "swal-validation-errors",
                  },
                  backdrop: `
                                    rgba(0,0,0,0.4)
                                    center
                                    no-repeat
                                `,
                });
                const swalValidationErrors = document.querySelector(
                  ".swal-validation-errors"
                ) as HTMLElement;
                if (swalValidationErrors) {
                  swalValidationErrors.style.zIndex = "10000";
                }
                e.target.value = "";
                setFormData((prev) => ({
                  ...prev,
                  phone: "",
                }));
              } else {
                // setFormData((prev) => ({
                //   ...prev,
                //   phone: value,
                // }));
                handleChange(e);
              }
            }}
            required
            pattern="[0-9]{10}"
            title="Mobile number should be 10 digits"
          />
        </div>

        <div className="form-group_org">
          <label
            style={{
              fontWeight: "bold",
              marginRight: "10px",
              whiteSpace: "nowrap",
            }}
          >
            Industry
          </label>
          <select name="industory" onChange={handleChange}>
            <option value="">Select Industry</option>
            <option value="Hardware">Hardware</option>
            <option value="Hardware_Paints">Hardware & Paints</option>
            <option value="Building_Material_Supplier"> Building Material Supplier</option>
            <option value="Die_Tools_Manufacturer">Die and Tools Manufacturer</option>
            <option value="Plumbing">Plumbing</option>
            <option value="Mobile">Mobile </option>
            <option value="Electronics">Electronics</option>
            <option value="Electrical">Electrical </option>
            <option value="Automobile">Automobile</option>
            <option value="Furniture">Furniture </option>
            <option value="Manufacturing">Manufacturing</option>
            <option value="Traders">Traders</option>
            <option value="Jewellery">Jewellery</option>
            <option value="AnimalFeed">Animal Feed</option>
            <option value="BookStores">Book Stores</option>
            <option value="FruitsAndVegetables">Fruits & Vegetables</option>
          </select>
        </div>

        <div className="form-group_org">
          <label
            style={{
              fontWeight: "bold",
              marginRight: "10px",
              whiteSpace: "nowrap",
            }}
          >
            Currency<span style={{ color: "red" }}>*</span>
          </label>
          <select name="currency" onChange={handleChange} required disabled>
            {/* <option value="">Select Currency</option> */}
            <option value="INR">INR - Indian Rupees</option>
          </select>
        </div>

        <div className="form-group_org">
          <label
            style={{
              fontWeight: "bold",
              marginRight: "10px",
              whiteSpace: "nowrap",
            }}
          >
            Time Zone<span style={{ color: "red" }}>*</span>
          </label>
          <select name="timeZone" onChange={handleChange} required disabled>
            {/* <option value="">Select Time Zone</option> */}
            <option value="IST">UTC+5:30 India Standard Time</option>
          </select>
        </div>

        <div className="form-group_org">
          <button type="button" onClick={handleAddAddressClick}>
            Add Org Address
          </button>
        </div>

        <div
          className="form-group_org"
          style={{ display: "flex", alignItems: "center" }}
        >
          <div style={{ display: "flex", alignItems: "center" }}>
            <input
              name="GST"
              type="checkbox"
              onChange={handleGSTCheckbox}
              style={{ marginRight: "10px", width: "15px" }}
            />
            <label
              htmlFor="gstCheckbox"
              style={{
                fontWeight: "bold",
                marginRight: "10px",
                marginTop: "7px",
                whiteSpace: "nowrap",
              }}
            >
              GST
            </label>
          </div>
        </div>

        {showGSTField && (
          <div className="form-group_org">
            <label
              style={{
                fontWeight: "bold",
                marginRight: "10px",
                whiteSpace: "nowrap",
              }}
            >
              GST Number
            </label>
            <input name="GST" type="text" onChange={handleChange} />
          </div>
        )}

        <div className="form-actions">
          <button type="submit">Submit</button>
          <button type="button" onClick={() => navigate("/")}>
            Cancel
          </button>
        </div>
      </form>

      {showAddressPopup && (
        <div className="popup">
          <div className="popup-content">
            <h3>Enter Address Details</h3>
            <div className="form-group_org">
              <label
                style={{
                  fontWeight: "bold",
                  marginRight: "10px",
                  whiteSpace: "nowrap",
                }}
              >
                Address Line 1
              </label>
              <input name="addressLine1" type="text" onChange={handleChange} />
            </div>
            <div className="form-group_org">
              <label
                style={{
                  fontWeight: "bold",
                  marginRight: "10px",
                  whiteSpace: "nowrap",
                }}
              >
                Address Line 2
              </label>
              <input name="addressLine2" type="text" onChange={handleChange} />
            </div>
            <div className="form-group_org">
              <label
                style={{
                  fontWeight: "bold",
                  marginRight: "10px",
                  whiteSpace: "nowrap",
                }}
              >
                City
              </label>
              <input name="city" type="text" onChange={handleChange} />
            </div>
            <div className="form-group_org">
              <label
                style={{
                  fontWeight: "bold",
                  marginRight: "10px",
                  whiteSpace: "nowrap",
                }}
              >
                State
              </label>
              {/* <input name="state" type="text" onChange={handleChange} /> */}
              <select
                name="state"
                value={formData.state}
                onChange={handleChange}
                required
                >
                <option value="">Select State</option>
                {indianStates.map((state) => (
                  <option key={state.value} value={state.value} >
                    {state.label}
                  </option>
                ))}
                </select>
            </div>
            <div className="form-group_org">
              <label
                style={{
                  fontWeight: "bold",
                  marginRight: "10px",
                  whiteSpace: "nowrap",
                }}
              >
                ZIP Code
              </label>
              <input name="zipCode" type="text" onChange={handleChange} />
            </div>
            <div className="form-actions">
              <button type="button" onClick={handleClosePopup}>
                Save Address
              </button>
              <button type="button" onClick={handleClosePopup}>
                Cancel
              </button>
            </div>
          </div>
        </div>
      )}

      {apiResponse && (
        <div className="popup">
          <div className="popup-content">
            <p>{apiResponse}</p>
            <button
              style={{ display: "block", margin: "0 auto" }}
              onClick={handleRedirect}
            >
              OK
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default OrgProfileForm;
